import { API_URL } from "../config"
import { getToken } from "../util/validation";

const token = JSON.parse(getToken);

export async function createZohoTask(formData){

    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'formData': formData
        }

        const response = await fetch(API_URL + 'adminpanel/create_zoho_task/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        console.log(token)
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}

export async function getZohoTasks(){

    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'adminpanel/get_zoho_task/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });
        console.log(token)
        if (response.status === 200) {

            return response.json()
        }
        else{
            
            return false
        }

    } catch (error) {
        return false
    }

}